export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cadena de"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["caracteres"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor no permitido"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo requerido"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revisa los campos"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Máx."])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG o JPG"])}
}